export default "__VITE_ASSET__3c30f9a4__"